export default __webpack_public_path__ + "src/images/home/sponsorship_leads-061e3fc03ce6f69f3869fdd202d9e333.jpg";